import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class HgService {
  constructor(private http: HttpClient) {}

  autenticarHg(email: string, senha: string) {
    return this.http
      .post<any>(`${environment.wsUrl}hg/authHg`, { email, senha })
      .toPromise();
  }

  salvarReAuth(emailHg: any, senhaHg: any, tokenLaudo: string) {
    return this.http
      .post<any>(`${environment.wsUrl}hg/SalvarReAuthHg`, { emailHg, senhaHg, tokenLaudo })
      .toPromise();
  }

  getDadosAvaliacaoHgUnion(tokenLaudo: string) {
    return this.http
      .get<any>(`${environment.wsUrl}hg/getDadosAvaliacaoHgUnion/${tokenLaudo}`)
      .toPromise();
  }

  montarListasHg(token: string) {
    return this.http
      .get<any[]>(`${environment.wsUrl}hg/getDadosAvaliacaoIniciaisHg/${token}`)
      .toPromise();
  }

  getAvaliacoesHg(token: any) {
    return this.http
      .get<any>(`${environment.wsUrl}hg/getAvaliacoesHg/${token}`)
      .toPromise();
  }

  async getDadosVeiculoHg(placa: string, token: string) {
    return this.http
      .get<any>(`${environment.wsUrl}hg/getDadosVeiculoHg/${placa}/${token}`)
      .toPromise();
  }

  getListaMarcasHg(token: string) {
    return this.http
      .get<any[]>(`${environment.wsUrl}hg/getListaMarcasHg/${token}`)
      .toPromise();
  }

  getListaModelosHg(makeId: string, token: string) {
    return this.http
      .get<any[]>(`${environment.wsUrl}hg/getListaModelosHg/${makeId}/${token}`)
      .toPromise();
  }

  getListaVersoesHg(modelId: string, token: string) {
    return this.http
      .get<any[]>(
        `${environment.wsUrl}hg/getListaVersoesHg/${modelId}/${token}`
      )
      .toPromise();
  }

  getListaItensAvaliacaoHg(token: string) {
    return this.http
      .get<any[]>(`${environment.wsUrl}hg/getListaItensAvaliacaoHg/${token}`)
      .toPromise();
  }

  getListaOpcionaisHg(token: string) {
    return this.http
      .get<any[]>(`${environment.wsUrl}hg/getListaOpcionaisHg/${token}`)
      .toPromise();
  }

  salvarAvaliacaoHg(dadosHg: any) {
    return this.http
      .post(`${environment.wsUrl}hg/salvarAvaliacaoHg`, dadosHg)
      .toPromise();
  }

  validarFormHg(tokenLaudo: string) {
    return this.http
      .get<any>(`${environment.wsUrl}hg/validarFormHg/${tokenLaudo}`)
      .toPromise();
  }
}
